import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { ShoppingCart } from "lucide-react";

type AddToCartButtonProps = {
  onAddToCart: () => void;
  canBeAddedToCart: boolean;
};

export function AddToCartButton({
  onAddToCart,
  canBeAddedToCart,
}: AddToCartButtonProps) {
  const [t] = useTranslation();

  return (
    <Button
      variant="outline"
      className="flex flex-row items-center gap-2 transition-transform active:scale-95"
      onClick={onAddToCart}
      disabled={!canBeAddedToCart}
    >
      <ShoppingCart />
      {t("cart.addToCart")}
    </Button>
  );
}
 